// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"WhatsNewAlert_buttonWrapper__FLUXE","whatsNewWrapper":"WhatsNewAlert_whatsNewWrapper__v7XXe"};